// CUSTOM PRODUCT IMAGES SLIDER
const caroussel = document.querySelector(".carousel")
const carousselInner = caroussel.querySelector(".carousel-inner")
const carousselDots = caroussel.querySelector(".carousel-indicators")
const items = caroussel.querySelectorAll(".carousel-item").length
const childElements = document.querySelectorAll('.carousel-inner > div');

caroussel.addEventListener("click", (e) => {
  if (e.target.classList.contains("carousel-control") || e.target.classList.contains("carousel-bullet")) {
    slideWithButton(e)
  } else if (e.target.classList.contains("carousel-item__img") || e.target.classList.contains("zoom-button")) {
    zoomCaroussel()
  }
})

function slideWithButton(e) {
  const control = e.target.dataset.control;
  const carousselWidth = caroussel.offsetWidth;
  if (window.innerWidth >= 771) {
    carousselInner.style.transform = `translateX(-${carousselWidth * control}px)`;
  } else {
    const nextChild = childElements[control];
    carousselInner.scrollTo({
      left: nextChild.offsetLeft,
      behavior: 'smooth'
    });
  }
}

function zoomCaroussel() {
  const fragment = new DocumentFragment();

    const container = document.createElement("div");
    const closeButton = document.createElement("button");
    const clonedCarousel = caroussel.cloneNode(true);
    const carouselInner = clonedCarousel.querySelector(".carousel-inner");
    carouselInner.style.transform = ""
    const dots = clonedCarousel.querySelector(".carousel-indicators");

    clonedCarousel.classList.remove("carousel");
    clonedCarousel.classList.add("clone-carousel");
    container.classList.add("opeen");
    closeButton.innerHTML = '<svg class="pswp__icn icon" stroke="currentColor" fill="none" viewBox="0 0 30 30"><path d="m7.5 22.5 15-15m-15 0 15 15"></path></svg>';
    closeButton.type = 'button';
    closeButton.classList.add("close-button");
    updateCarouselIds(clonedCarousel, 'carousel', 'carousel-clone');
    dots.remove();

    container.appendChild(closeButton);
    container.appendChild(clonedCarousel);
    fragment.appendChild(container);
    document.body.appendChild(fragment);
    closeButton.addEventListener("click", () => {container.remove()})
}

function updateCarouselIds(clonedCarousel, oldIdPrefix, newIdPrefix) {
  const inputs = clonedCarousel.querySelectorAll('input');
  inputs.forEach((input, index) => {
    input.id = `${newIdPrefix}-${index}`;
    input.name = `${newIdPrefix}`
  });

  const labels = clonedCarousel.querySelectorAll('label');
  labels.forEach((label) => {
    const oldForValue = label.getAttribute('for');
    if (oldForValue && oldForValue.startsWith(oldIdPrefix)) {
      const newForValue = oldForValue.replace(oldIdPrefix, newIdPrefix);
      label.setAttribute('for', newForValue);
    }
  });

  const imgs = clonedCarousel.querySelectorAll('img');
  imgs.forEach((img) => {
    const oldSrcValue = img.getAttribute('src');
    img.setAttribute("src", oldSrcValue.replaceAll("width=600", `width=${window.innerHeight}`))
  })
}

let isDown = false;
let startX;
let currentTranslate = 0;
let prevTranslate = 0;
let currentIndex = 0;
const totalSlides = document.querySelectorAll('.carousel-item').length;



document.addEventListener("onload", () => {
  carousselInner.scrollTo({
    left: 0,
    behavior: 'smooth'
  });
});

let currentSlideElement = 0;
carousselInner.addEventListener('touchend', () => {
  let scrollLeft = carousselInner.scrollLeft;
  let parentWidth = carousselInner.clientWidth;

  let childOffsetLeft = childElements[currentSlideElement].offsetLeft;
  let childWidth = childElements[currentSlideElement].clientWidth;

  if (scrollLeft >= childOffsetLeft + (childWidth / 2) - parentWidth / 2) {
    if (currentSlideElement < childElements.length - 1) {
      const nextChild = childElements[currentSlideElement + 1];
      carousselInner.scrollTo({
        left: nextChild.offsetLeft,
        behavior: 'smooth'
      });
      currentSlideElement += 1;
    }
  } else if (scrollLeft <= childOffsetLeft + (childWidth / 2) - parentWidth / 5) {
    if (currentSlideElement > 0) {
      const nextChild = childElements[currentSlideElement - 1];
      carousselInner.scrollTo({
        left: nextChild.offsetLeft,
        behavior: 'smooth'
      });
      currentSlideElement -= 1;
    }
  }
});

// CUSTOM ACCORDION
window.faqSec = true;
document.querySelectorAll(".accordion .details summary").forEach((element) =>
  element.addEventListener("click", (event) => {
    event.preventDefault();
    const detailsElement = event.target.parentElement;
    const contentElement = event.target.nextElementSibling;
    const contentInvisibleElement = contentElement.nextElementSibling;
    const contentInvisibleElementMobile = contentElement.nextElementSibling.nextElementSibling;
    let height = contentInvisibleElement.offsetHeight;
    let heightMobile = "";
    if (contentInvisibleElementMobile) {
      heightMobile = contentInvisibleElementMobile.offsetHeight;
    }

    detailsElement.classList.toggle("active");
    if (window.innerWidth > 770 || !contentInvisibleElementMobile) {
      if (detailsElement.classList.contains("active")) {
        contentElement.style.height = `${height}px`;
      } else {
        contentElement.style.height = "0px";
      }
    } else {
      if (detailsElement.classList.contains("active")) {
        contentElement.style.height = `${heightMobile}px`;
      } else {
        contentElement.style.height = "0px";
      }
    }
  })
);

// Extra 
window.addEventListener("load", (event) => {
  const afterpayElement = document.querySelector("square-placement");
  var sheet = new CSSStyleSheet
  sheet.replaceSync( `@media screen and (max-width: 770px) { .afterpay-paragraph { justify-content: center;
    align-items: center;
    display: flex;
    flex-direction: column; }  }`);
  afterpayElement.shadowRoot.adoptedStyleSheets.push(sheet)
});